import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { LoadingAction } from 'src/app/models/loading-action.model';

@Component({
  selector: 'tx-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit {
  @Input() height = '100vh';
  @Input() loadingAction: string = LoadingAction.Loading.toString();
  @Input() isPdf: boolean = false;

  @HostBinding('style.position') position: string = 'fixed';

  constructor() {}

  ngOnInit(): void {
    if (this.isPdf) {
      this.position = 'absolute';
    }
  }
}
